import React from "react";

type TProps = {
  input: any;
  register: any;
}

function Radiobutton({input, register}: TProps) {
  return (
    <div className="radio-buttons-block">
      {input.values.map((item: any, key: number) => {
        return (
          <label className="radiobutton-field flex" key={key}>
            <input
              className="w-0 h-0"
              type="radio"
              value={item.value}
              {...register(input?.name || '', { required: input?.required })}
            />
            <div className="radiobutton" />
            <div className="radiobutton-name pl-2">{item.value}</div>
          </label>
        )
      })}
    </div>
  )
}

export default Radiobutton;
